import DateInput from "@/components/DateInput";
import { fmtDate, riyadhToday } from "@/lib/format";

export const PERIOD_LABELS = {
  today: "Today", month: "Current month", last_month: "Last month", last3: "Last 3 months", last6: "Last 6 months",
  fy: "Current financial year", last_fy: "Last financial year", custom: "Custom range",
  prev_return: "Previous return period", cur_return: "Current return period",
};

const iso = (Y, M, D) => new Date(Date.UTC(Y, M - 1, D)).toISOString().slice(0, 10);

export const rangeFor = (p) => {
  const t = riyadhToday();
  const [y, m, d] = t.split("-").map(Number);
  return {
    today: [t, t], month: [iso(y, m, 1), iso(y, m + 1, 0)], last_month: [iso(y, m - 1, 1), iso(y, m, 0)],
    last3: [iso(y, m - 3, d + 1), t], last6: [iso(y, m - 6, d + 1), t], fy: [iso(y, 1, 1), iso(y, 12, 31)],
    last_fy: [iso(y - 1, 1, 1), iso(y - 1, 12, 31)],
  }[p];
};

export const returnRange = (freq, offset = 0) => {
  const [y, m] = riyadhToday().split("-").map(Number);
  const len = freq === "quarterly" ? 3 : 1;
  const start = (freq === "quarterly" ? Math.floor((m - 1) / 3) * 3 + 1 : m) + offset * len;
  return [iso(y, start, 1), iso(y, start + len, 0)];
};

export const returnLabel = (freq, from) => {
  const [y, m] = from.split("-").map(Number);
  return freq === "quarterly" ? `Q${Math.floor((m - 1) / 3) + 1} ${y}` : new Date(Date.UTC(y, m - 1, 1)).toLocaleString("en-GB", { month: "long", year: "numeric", timeZone: "UTC" });
};

export default function PeriodBar({ periods, period, from, to, onPeriod, onFrom, onTo }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="period-bar">
      {periods.map((v) => (
        <button key={v} type="button" onClick={() => onPeriod(v)} data-testid={`period-${v}`}
          className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-colors duration-150 ${period === v ? "bg-emerald-800 text-white border-emerald-800" : "bg-white text-slate-600 border-slate-200 hover:border-emerald-400"}`}>{PERIOD_LABELS[v]}</button>
      ))}
      {period === "custom" ? (
        <div className="flex items-center gap-1.5">
          <div className="w-[150px]"><DateInput value={from} onChange={onFrom} className="h-8 text-xs" testid="period-custom-from" /></div>
          <span className="text-xs text-slate-400">to</span>
          <div className="w-[150px]"><DateInput value={to} onChange={onTo} className="h-8 text-xs" testid="period-custom-to" /></div>
        </div>
      ) : <span className="num text-xs text-slate-500 ml-1" data-testid="period-range-label">{fmtDate(from)} – {fmtDate(to)}</span>}
    </div>
  );
}
